// Backend API Response format
export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
  timestamp: number;
}

export interface DataVersion {
  version: number;
  timestamp: number;
  data: any;
  updatedBy: string;
}

export interface ServiceError {
  code: string;
  message: string;
  details?: any;
}

// API Response interfaces
export interface LoginApiResponse {
  token: string;
  refreshToken: string;
  user: {
    username: string;
    lastLogin?: string;
  };
  expiresIn: number;
}

export interface DataApiResponse {
  version: number;
  data: any;
  updatedBy: string;
  updatedAt: string;
  createdAt?: string;
}

export enum StorageKeys {
  AUTH_SESSION = 'urubu_auth_session',
  LINKS_DATA = 'urubu_links_data',
  DATA_VERSION = 'urubu_data_version',
  DATA_BACKUP = 'urubu_data_backup'
}